<template>
  <div class="enterprise-info">
    <el-form
      class="apiForm"
      ref="formRef"
      label-position="top"
      :rules="rules"
      :model="info"
    >
      <el-form-item label="企业名称" required prop="name">
        <el-input v-model="info.name" placeholder="请输入企业名称"></el-input>
      </el-form-item>
      <el-form-item
        label="统一社会信用代码或注册号"
        required
        prop="register_no"
      >
        <el-input
          v-model="info.register_no"
          placeholder="请输入证件号码"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="法人名称" required prop="legal_person">
        <el-input
          v-model="info.legal_person"
          placeholder="请输入法人名称"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="企业执照" required prop="license_img">
        <div class="upload">
          <file-pond
            ref="refUpload"
            v-if="ifRenderFilePond"
            label-idle="上传"
            v-bind:allow-multiple="false"
            :acceptedFileTypes="acceptedFileTypes.join(',')"
            @handleAfterRead="handleAfterRead"
            @addfile="handleAddFile"
          >
          </file-pond>
          <div class="upload-main" ref="refUploadContent">
            <img
              v-if="!info.license_img"
              class="no-upload-img"
              src="@/assets/img/auth/upload-icon.png"
              alt=""
            />
            <div class="w-[100%] h-[100%] box-border px-[20px]" v-else>
              <img
                class="w-[100%] h-[100%]"
                :src="getObjectStorageFullUrl(info.license_img)"
                alt=""
              />
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="flex mt-[16px]">
      <div
        class="pointer flex-center w-[130px] h-[40px] text-[14px] font-[700] text-[#000] rounded-[40px] bg-[transparent] border border-solid border-black mr-[12px]"
        @click="handleCancel"
      >
        取消
      </div>
      <div
        v-if="!noChangeSubmit"
        class="relative w-[130px] h-[40px] flex justify-center items-center bg-black text-white rounded-full text-sm font-medium disabled:opacity-80"
        @click="confirmCertifyEnterprise"
        :class="{ pointer: !isLoading }"
      >
        <span :class="isLoading ? 'opacity-0' : 'opacity-100'">提交认证</span>
        <div
          v-if="isLoading"
          class="absolute w-5 h-5 border-2 border-t-white rounded-full border-solid animate-[spin_3s_linear_infinite]"
        ></div>
      </div>
      <div
        v-if="noChangeSubmit"
        class="relative w-[130px] h-[40px] flex justify-center items-center bg-[rgba(0,0,0,0.1)] text-[#fff] rounded-full text-sm font-medium disabled:opacity-80 cursor-not-allowed"
      >
        提交认证
      </div>
    </div>
    <div v-if="errorText.length" class="pt-[4px]] text-[red] text-[12px]">
      <div class="mt-[2px]" v-for="item in errorText" :key="item">
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  defineEmits,
  onMounted,
  nextTick,
  watch,
  computed,
} from "vue";
import vueFilePond from "vue-filepond";
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js";
import message from "@/components/functionCallComponent/message.jsx";
import { certifyInfo } from "@/api/api/apiKey.js";
import useUserDataStore from "@/store/userDataStore";

const emits = defineEmits(["cancelSubmit"]);
const userDataStore = useUserDataStore();
const acceptedFileTypes = [
  "image/*",
  "image/jpeg",
  "image/png",
  "image/webp", // 添加你最需要支持的格式
];
const ERROR_MAPPING = {
  7001: "个人信息校验不一致",
  7002: "个人实名认证审核失败",
  7003: "企业认证审核失败",
  7006: "企业名称不一致",
  7007: "营业执照号不一致",
  7008: "企业经营状态异常",
  7009: "该企业已认证，不支持重复认证",
  7010: "无法识别营业执照信息，请重新上传",
  7011: "您填写的信息与营业执照识别结果不一致，请重新填写",
  7012: "企业认证 30 天内仅支持编辑一次",
};

const FilePond = vueFilePond();
const refUpload = ref(null);
const formRef = ref(null);
const refUploadContent = ref(null);
const ifRenderFilePond = ref(true);
const errorText = ref([]);
const info = reactive({
  t: 1,
  name: "",
  register_no: "",
  // legal_person: "",
});
const rules = reactive({
  name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
  register_no: [
    { required: true, message: "请输入统一社会信用代码", trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        if (value.length <= 10) {
          callback(new Error("请输入正确的统一社会信用代码"));
        } else {
          callback();
        }
      },
      trigger: ["blur", "change"],
    },
  ],
  license_img: [{ required: true, message: "请上传营业执照", trigger: "blur" }],
});
const isLoading = ref(false);

// 初始化上传内容
const initUploadContent = () => {
  if (refUploadContent.value) {
    nextTick(() => {
      refUpload.value?.$el
        .querySelector(".filepond--drop-label")
        .appendChild(refUploadContent.value);
    });
    setTimeout(() => {
      refUpload.value?.$el
        ?.querySelector("input")
        ?.setAttribute("accept", acceptedFileTypes.join(","));
    }, 20);
  }
};
const handleAddFile = async (error, fileItem, fileList) => {
  if (error) {
    console.error("File add error:", error);
    return;
  }
  handleAfterRead(fileItem.file);
};

const handleAfterRead = async (file) => {
  if (file.size > 1024 * 1024 * 100) {
    message.info({
      position: "top",
      content: "文件不可超过100Mb",
    });
    return;
  }
  nextTick(() => {
    ifRenderFilePond.value = true;
    nextTick(() => {
      initUploadContent();
    });
  });
  const { pathKey } = await objectStorage.uploadFileToObjectStorage(file);
  console.log(pathKey, "pathKey");
  info.license_img = pathKey;
  // 上传成功后清空错误信息
  if (errorText.value.length > 0) {
    errorText.value = [];
  }
  // console.log(objectStorageRes, "objectStorageRes")
};

const noChangeSubmit = computed(() => {
  console.log(info.name, userDataStore?.certificationDetail?.name, "info.name");
  console.log(
    info.register_no,
    userDataStore?.certificationDetail?.register_no,
    "info.register_no"
  );
  console.log(
    info.license_img,
    userDataStore?.certificationDetail?.license_img,
    "info.license_img"
  );
  return (
    info.name == userDataStore?.certificationDetail?.name &&
    info.register_no === userDataStore?.certificationDetail?.register_no &&
    info.license_img === userDataStore?.certificationDetail?.license_img
  );
});

const confirmCertifyEnterprise = () => {
  console.log("noChangeSubmit", noChangeSubmit.value);
  console.log("isLoading", isLoading.value);
  console.log("info", info);
  if (isLoading.value) return;
  console.log("info", info);

  formRef.value.validate((valid, fields) => {
    if (valid) {
      isLoading.value = true;
      certifyInfo(info)
        .then((res) => {
          if (res.code === 200) {
            if (res.data?.err_code) {
              const err_code = res.data.err_code;
              errorText.value = err_code
                .map((code) => ERROR_MAPPING[code])
                .filter(Boolean);
            } else {
              errorText.value = [];
              ElMessage.success("认证成功");
              userDataStore.getUserCertificationState();
              emits("confirmSumbit");
            }
          }
        })
        .finally(() => {
          isLoading.value = false;
        });
      // console.log("submit!");
    } else {
      // console.log("error submit!", fields);
    }
  });
};

const handleCancel = () => {
  emits("cancelSubmit");
};

// 监听表单字段变化，清空错误信息
watch(
  [() => info.name, () => info.register_no, () => info.license_img],
  () => {
    // 清空自定义错误信息
    if (errorText.value.length > 0) {
      errorText.value = [];
    }
    // 清空Element Plus表单验证错误
    if (formRef.value) {
      formRef.value.clearValidate();
    }
  },
  { deep: true }
);

onMounted(() => {
  const certificationDetail = userDataStore.certificationDetail;
  const certificationState = userDataStore.certificationState;
  if (certificationState == 1) {
    if (certificationDetail.name) {
      info.name = certificationDetail.name;
    }
    if (certificationDetail.register_no) {
      info.register_no = certificationDetail.register_no;
    }
    if (certificationDetail.license_img) {
      info.license_img = certificationDetail.license_img;
    }
  }

  nextTick(() => {
    initUploadContent();
  });
});
</script>

<style lang="scss">
.enterprise-info {
  input {
    color: #000;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
  }
  input::placeholder {
    color: rgba(0, 0, 0, 0.2) !important;
  }
  .el-input__wrapper {
    box-shadow: none !important;
    // border:  1px solid rgba(0, 0, 0, 0.1);
    padding: 0;
    .is-focus {
      box-shadow: 1px #000 !important;
    }
  }
  .el-form-item__label {
    color: #000;
  }
  .el-input__inner {
    border-radius: 6px;
    padding: 0 12px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    height: 44px;
  }
  .el-input__inner:focus {
    border: 1px solid #000;
    // border: 1px solid #000;
  }

  .el-form-item__error {
    padding-top: 4px;
  }
  .upload {
    width: 140px;
    --filepond-border-radius: 8px;
    --filepond-min-height: 80px;
    --filepond-min-height: 80px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    line-height: 0;
    .filepond--root {
      height: max-content !important;
      min-height: var(--filepond-min-height) !important;
      background: transparent;
      box-shadow: none;
      align-items: center;
      justify-content: center;
      border-radius: var(--filepond-border-radius);
      margin: 0;
      contain: unset !important;
      .filepond--wrapper {
        // height: max-content !important;
        border-radius: var(--filepond-border-radius);
      }
      .filepond--browser.filepond--browser {
        height: 0;
      }
      .filepond--list-scroller {
        display: none;
      }
      .filepond--credits {
        display: none;
      }

      .filepond--panel-root {
        border-radius: 0.5em;
        background: transparent;
        box-shadow: none;
        border-radius: max-content;
        display: none;
      }

      .filepond--assistant {
        display: none;
      }
      .filepond--browser {
        display: none;
      }
      .filepond--drop-label {
        display: block;
        position: unset !important;
        visibility: visible !important;
        transform: translate3d(0px, 0, 0px) !important;
        height: max-content !important;
        border-radius: var(--filepond-border-radius) !important;
        min-height: var(--filepond-min-height) !important;
        opacity: 1 !important;
        pointer-events: auto !important;
        & > label {
          width: 0;
          height: 0;
          overflow: hidden;
          padding: 0;
          display: block;
        }
      }
      fieldset {
        display: none;
      }
    }
    .upload-main {
      height: 80px;
      background: rgba(154, 168, 193, 0.1);
      .no-upload-img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
